import type {components, paths} from '../../openapi/auth.swagger';
import {axiosInstance} from '../axiosInstance';

type UpdateInnOperation = paths['/executor_web/identification/inn']['patch'];

export type UpdateInnRequest = NonNullable<
	NonNullable<UpdateInnOperation['requestBody']>['content']['application/json']
>;
export type UpdateInnResponse = UpdateInnOperation['responses'][200]['content']['application/json'];
export type UpdateInnErrorResponse = components['schemas']['Error'];

/** PATCH `/executor_web/identification/inn` — см. `paths['/executor_web/identification/inn']` в auth swagger */
export function updateInn(request: UpdateInnRequest, signal?: AbortSignal) {
	return axiosInstance.patch<UpdateInnResponse>('identification/inn', request, {signal});
}
